
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/search",
      function () {
        return require("private-next-pages/resources/search.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/search"])
      });
    }
  